import { Injectable, EventEmitter } from "@angular/core";
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpErrorResponse
} from "@angular/common/http";

import { AppConfig } from "../../app/app.config";
import { Device } from "@ionic-native/device";

import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/share";
import { AlertController } from "ionic-angular";

@Injectable()
export class Api {
  protected url: string = AppConfig.API_URL_BASE;
  private defaultRequestOptions: any = {
    headers: new HttpHeaders(),
    params: new HttpParams()
  };

  navigationEvent = new EventEmitter();

  constructor(
    public http: HttpClient,
    protected device: Device,
    public alertCtrl: AlertController
  ) {}

  initializeHeader(): void {
    this.clearHeader();
    if (this.device.platform && !AppConfig.IS_BROWSER) {
      this.setHeader("X-Pariv-App-Id", AppConfig.BUNDLE_ID);
      this.setHeader("X-Pariv-App-Version-Code", AppConfig.APP_VERSION_CODE);
      this.setHeader("X-Pariv-App-Version", AppConfig.APP_VERSION);
      this.setHeader("X-Pariv-Model", this.device.model || "null");
      this.setHeader("X-Pariv-Os", this.device.platform);
      this.setHeader("X-Pariv-Os-Version", this.device.version);
      this.setHeader("X-Pariv-Uuid", this.device.uuid);
    } else {
      this.setHeader("X-Pariv-App-Id", "");
      this.setHeader("X-Pariv-App-Version-Code", "1");
      this.setHeader("X-Pariv-App-Version", "2.0.0");
      this.setHeader("X-Pariv-Model", "pc");
      this.setHeader("X-Pariv-Os", "");
      this.setHeader("X-Pariv-Os-Version", "1.0.0");
      this.setHeader("X-Pariv-Uuid", "pc" + new Date().getTime());
    }
  }

  setHeader(key: string, value: string): void {
    // HttpHeaders is immutable
    this.defaultRequestOptions.headers = this.defaultRequestOptions.headers.set(
      key,
      value
    );
  }

  clearHeader(): void {
    this.defaultRequestOptions.headers = new HttpHeaders();
  }

  resetParams(): void {
    if (this.defaultRequestOptions.params)
      this.defaultRequestOptions.params = new HttpParams();
  }

  get(endpoint: string, v2?: boolean, params?: any): Observable<any> {
    this.resetParams();
    if (params) {
      let httpParams = new HttpParams();
      for (let k in params) {
        httpParams = httpParams.set(k, params[k]);
      }
      this.defaultRequestOptions.params = httpParams;
      delete this.defaultRequestOptions.observe;
    }

    let seq = this.http
      .get(this.getAppUrl(v2) + "/" + endpoint, this.defaultRequestOptions)
      .share();
    seq.subscribe(
      data => {
        console.log("*** get : " + endpoint);
        console.log(data);
      },
      (httpError: HttpErrorResponse) => {
        console.log("*** get error : " + endpoint);
        console.log(httpError);
        this.show422ErrorAlert(httpError);
      }
    );
    return seq;
  }

  getCompleteResponse(endpoint: string, params?: any): Observable<any> {
    // TODO: paramsを受け取れるように
    this.resetParams();
    if (params) {
      let httpParams = new HttpParams();
      for (let k in params) {
        httpParams = httpParams.set(k, params[k]);
      }
      this.defaultRequestOptions.params = httpParams;
      this.defaultRequestOptions.observe = "response";
    }
    let seq = this.http
      .get<any>(this.url + "/" + endpoint, this.defaultRequestOptions)
      .share();
    seq.subscribe(
      data => {
        console.log("*** get : " + endpoint);
        console.log(data);
      },
      (httpError: HttpErrorResponse) => {
        console.log("*** get error : " + endpoint);
        console.log(httpError);
        this.show422ErrorAlert(httpError);
      }
    );
    delete this.defaultRequestOptions.observe;
    return seq;
  }

  post(endpoint: string, body: any, v2?: boolean): Observable<any> {
    this.resetParams();
    let seq = this.http
      .post(
        this.getAppUrl(v2) + "/" + endpoint,
        body,
        this.defaultRequestOptions
      )
      .share();
    seq.subscribe(
      (data) => {
        console.log("*** post : " + endpoint);
        console.log(data);
      },
      (httpError: HttpErrorResponse) => {
        console.log("*** post error : " + endpoint);
        console.log(httpError);
        this.show422ErrorAlert(httpError);
      }
    );
    return seq;
  }

  put(endpoint: string, body: any, v2?: boolean): Observable<any> {
    this.resetParams();
    let seq = this.http
      .put(this.getAppUrl(v2) + "/" + endpoint, body, this.defaultRequestOptions)
      .share();
    seq.subscribe(
      data => {
        console.log("*** put : " + endpoint);
        console.log(data);
      },
      (httpError: HttpErrorResponse) => {
        console.log("*** put error : " + endpoint);
        console.log(httpError);
        this.show422ErrorAlert(httpError);
      }
    );
    return seq;
  }

  patch(endpoint: string, body: any): Observable<any> {
    this.resetParams();
    let seq = this.http
      .put(this.url + "/" + endpoint, body, this.defaultRequestOptions)
      .share();
    seq.subscribe(
      data => {
        console.log("*** patch : " + endpoint);
        console.log(data);
      },
      (httpError: HttpErrorResponse) => {
        console.log("*** patch error : " + endpoint);
        console.log(httpError);
        this.show422ErrorAlert(httpError);
      }
    );
    return seq;
  }

  delete(endpoint: string, v2?: boolean, body?: any): Observable<any> {
    this.resetParams();
    if (body) {
      let httpParams = new HttpParams();
      for (let k in body) {
        httpParams = httpParams.set(k, body[k]);
      }
      this.defaultRequestOptions.params = httpParams;
    }
    let seq = this.http
      .delete(this.getAppUrl(v2) + "/" + endpoint, this.defaultRequestOptions)
      .share();
    seq.subscribe(
      data => {
        console.log("*** delete : " + endpoint);
        console.log(data);
      },
      (httpError: HttpErrorResponse) => {
        console.log("*** delete error : " + endpoint);
        console.log(httpError);
        this.show422ErrorAlert(httpError);
      }
    );
    return seq;
  }

  private getAppUrl(v2?: boolean): string {
    if (v2) {
      //　ここもV2開発の時使うから残しておく
      console.log("V2!!!!");
      return AppConfig.API_URL_BASE_V2;
    } else {
      console.log("V1!!!!!");
      return AppConfig.API_URL_BASE;
    }
  }

  private show422ErrorAlert(httpError: HttpErrorResponse): void {
    if (httpError.status === 422) {
      const msg: string = httpError.error.error_messages.join("\n");
      let rightButtonLink: Function = null;
      let leftButtonLink: Function = null;
      if (httpError.error.right_button_link) {
        rightButtonLink = () => {
          this.navigationEvent.next({
            page: httpError.error.right_button_link
          });
        };
      }
      if (httpError.error.left_button_link) {
        leftButtonLink = () => {
          this.navigationEvent.next({
            page: httpError.error.left_button_link
          });
        };
      }

      let rightButtonMsg: string = null;
      let leftButtonMsg: string = null;
      if (httpError.error.right_button_message) {
        rightButtonMsg = httpError.error.right_button_message;
      }
      if (httpError.error.left_button_message) {
        leftButtonMsg = httpError.error.left_button_message;
      }

      if (rightButtonMsg && leftButtonMsg) {
        const alert = this.alertCtrl.create({
          title: httpError.error.error_title,
          subTitle: msg,
          buttons: [
            {
              text: leftButtonMsg,
              handler: () => {
                if (leftButtonLink !== null) {
                  leftButtonLink();
                }
              }
            },
            {
              text: rightButtonMsg,
              handler: () => {
                if (rightButtonLink !== null) {
                  rightButtonLink();
                }
              }
            }
          ]
        });
        alert.present();
        return;
      }

      if (rightButtonMsg && leftButtonMsg === null) {
        const alert = this.alertCtrl.create({
          title: httpError.error.error_title,
          subTitle: msg,
          buttons: [
            {
              text: "閉じる"
            },
            {
              text: rightButtonMsg,
              handler: () => {
                if (rightButtonLink !== null) {
                  rightButtonLink();
                }
              }
            }
          ]
        });
        alert.present();
        return;
      }

      if (rightButtonMsg === null && leftButtonMsg) {
        const alert = this.alertCtrl.create({
          title: httpError.error.error_title,
          subTitle: msg,
          buttons: [
            {
              text: leftButtonMsg,
              handler: () => {
                if (leftButtonLink !== null) {
                  leftButtonLink();
                }
              }
            },
            {
              text: "閉じる"
            }
          ]
        });
        alert.present();
        return;
      }

      // rightButtonMsgもleftButtonMsgもどちらもnull
      const alert = this.alertCtrl.create({
        title: httpError.error.error_title,
        subTitle: msg,
        buttons: [
          {
            text: "閉じる"
          }
        ]
      });
      alert.present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts